module.exports = __webpack_public_path__ + "assets/2b7d104851bd44179d0e03f01bd8db12.mp4";